import * as types from './types';

const setCurrentUser = decoded => {
	return {
		type: types.SET_CURRENT_USER,
		payload: decoded
	};
};

const getLoggedUser = data => {
	return {
		type: types.GET_LOGGED_USER,
		payload: data
	};
};

const clearCurrentUser = () => {
	return {
		type: types.CLEAR_CURRENT_USER
	};
};

const clearResponse = () => {
	return {
		type: types.CLEAR_RESPONSE
	};
};

export default {
	setCurrentUser,
	getLoggedUser,
	clearCurrentUser,
	clearResponse
};
